// extracted by mini-css-extract-plugin
export const section = "povezave-module--section--2FujX";
export const container = "povezave-module--container--2x5gh";
export const pageContent = "povezave-module--pageContent--3usS4";
export const footer = "povezave-module--footer--2d_63";
export const modal = "povezave-module--modal--39tWM";
export const pContainer = "povezave-module--pContainer--21Jzl";
export const wrap = "povezave-module--wrap--2h7M5";